var exports = {
  "k": "x61f99309--36fc52--container",
  "v": "x61f99309--36fc52--inner",
};

module.exports = exports;
